var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOffFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 0.5H38.5566C48.1083 0.50015 55.8514 8.24326 55.8516 17.7949V38.5566C55.8514 48.1083 48.1083 55.8514 38.5566 55.8516H17.7949C8.24326 55.8514 0.500151 48.1083 0.5 38.5566V17.7949C0.500174 8.24328 8.24328 0.500174 17.7949 0.5Z",
    fill: "url(#paint0_linear_60_15093)",
    stroke: "url(#paint1_linear_60_15093)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_15093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2974 34.4524C39.9601 32.3386 40.8605 29.7511 40.8605 27.0929C40.8605 26.4 40.2796 25.8345 39.568 25.8345C38.8565 25.8345 38.2756 26.4 38.2756 27.0929C38.2756 29.0865 37.6439 31.0307 36.4531 32.6567L38.2974 34.4524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4258 27.093V18.6872C37.4258 13.8444 33.3742 9.89954 28.3933 9.89954C24.3345 9.90661 20.7766 12.5365 19.6875 16.34L35.8429 32.0701C36.874 30.6067 37.4258 28.8675 37.4258 27.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3596 44.9079L11.7688 11.2279C11.2606 10.7401 10.4401 10.7542 9.93908 11.2491C9.4526 11.7369 9.4526 12.5146 9.93908 13.0095L19.1168 21.9385V28.0538C19.1241 32.9106 23.1611 36.8414 28.1493 36.8485C29.8702 36.8485 31.5547 36.3677 33.0069 35.4628L33.6168 36.0566C31.9976 37.11 30.0953 37.6685 28.1493 37.6685C22.7037 37.6685 18.2746 33.356 18.2746 28.0538C18.26 27.3609 17.6646 26.8095 16.9531 26.8236C16.2633 26.8378 15.7042 27.3821 15.6897 28.0538C15.6897 34.3175 20.5908 39.4854 26.8642 40.1217V45.7845C26.8642 46.4774 27.445 47.0429 28.1566 47.0429C28.8682 47.0429 29.449 46.4774 29.449 45.7845V40.1288C31.6273 39.9096 33.7112 39.132 35.4828 37.8736L44.5299 46.6895C45.0381 47.1843 45.8513 47.1843 46.3596 46.6895C46.8606 46.1946 46.8606 45.3957 46.3596 44.9079Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_15093",
    x1: 7.46367,
    y1: 1.51535,
    x2: 66.078,
    y2: 113.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_15093",
    x1: 6.75247,
    y1: -0.00000107404,
    x2: 62.2308,
    y2: 49.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#460BBD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_15093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(9.17578 9.1759)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOffFill);
export default __webpack_public_path__ + "static/media/mic_off_fill.f98b43591b7c239c631c25651e79f31c.svg";
export { ForwardRef as ReactComponent };